import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import Hero from "@/pages/home/components/Hero";
import ChefPicks from "@/pages/home/components/ChefPicks";
import Combos from "@/pages/home/components/Combos";
import WhySando from "@/pages/home/components/WhySando";
import HowToOrder from "@/pages/home/components/HowToOrder";
import Location from "@/pages/home/components/Location";
import InstagramStrip from "@/pages/home/components/InstagramStrip";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <ChefPicks />
        <Combos />
        <WhySando />
        <HowToOrder />
        <Location />
        <InstagramStrip />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}